import Vuex from 'vuex'

import common from './modules/common'  //공통
import userInfo from "./user/UserInfo";

export default new Vuex.Store({
    modules: {
        common,
        userInfo

    },
    // plugins: [createPersistedState()]
})
